<template>
  <v-row no-gutters class="groupSlide">
    <div class="groupSlide__box py-1">
      <v-sheet
        class="mx-auto"
        elevation="8"
      >
        <v-slide-group
          v-model="modelSile"
          class="pa-4"
          center-active
          show-arrows
          ref="slideGroup"
          @change="$emit('getSelectMedia', modelSile)"
        >
          <v-slide-item
            v-for="(item, idx) in listMedia"
            :key="idx"
            v-slot="{ active, toggle }"
          >
            <v-card
              :color="active ? 'primary' : 'grey lighten-1'"
              class="ma-1"
              height="60"
              width="80"
              @click="toggle"
            >
            <v-img
              :src="item.thumbnail"
            ></v-img>
            </v-card>
          </v-slide-item>
          <template slot="next">
            <v-btn icon @click="$emit('nextListMedia')" class="customButtonNext">
              <i class="far fa-chevron-right"></i>
            </v-btn>
          </template>
        </v-slide-group>
      </v-sheet>
    </div>
  </v-row>
</template>
<script>
export default {
  name:"GroupSlideMedia",
  props: ['listMedia', 'model'],
  data() {
    return {
      modelSile: this.model
    }
  }
};
</script>
<style lang="scss">

</style>